import { TemplateRef } from "@angular/core";

export type TableCompareFn = (a: string | number, b: string | number) => number;

export type TableColumnDataSortType = TableColumnData["dataType"];

export interface TableColumnData {
  /** The `item` object key (property) */
  key: string;
  /** The translation key (i18n) */
  tKey: string;
  dataType: "string" | "number" | "date" | "phone" | "currency" | "status" | "custom" | "rowSelect" | "projectTemplate";
  sortable: boolean;
  hidden?: boolean;
  cellClasslist?: string;
  /** Extra CSS classes for the column header cell (e.g., "text-end" to right-align the header) */
  headerClasslist?: string;
  /** Stick the column for the horizontal scroll */
  stickyColumn?: boolean;
  /** Column width (e.g., "160px", "20%", "auto") - sets width, max-width, and min-width */
  width?: string;
  customDataType?: TableCustomDataType;
  /** ISO 4217 currency code used when dataType === "currency" (e.g., "USD", "EUR"). Defaults to "USD". */
  currencyCode?: string;
  /** When dataType === "status" — status values that should render a loading spinner */
  spinnerStatuses?: string[];
  projectColumnTemplate?: TemplateRef<any>; // should be assigned after the view has been initialized (ngAfterViewInit)
  /** When dataType === "custom" */
  customDataOptions?: (row: unknown) => TableCustomDataOptions;
  /** When dataType === "rowSelect" — determines if a row's checkbox is enabled */
  isRowSelectable?: (row: unknown) => boolean;
  /** Tooltip text shown when row selection is disabled (used with isRowSelectable) */
  disabledSelectTooltip?: string;
}

export interface TableCellAction {
  actionType: TableCellActionType;
  /** When dataType === "custom" */
  customTypeValue?: string;
}

export type TableCellActionType = "edit" | "delete" | "view" | "custom" | "enable" | "disable";

export type TableCustomDataType = "active" | "check" | "status" | "link";

export type TableCustomDataOptions = TableCustomDataLinkOptions;

export type TableCustomDataLinkOptions = {
  linkName: string;
  /** Full URL. Once `linkUrl` or `redirectTo` is required */
  linkUrl?: string;
  onClick?: () => void;
  /** Relative URL. Once `linkUrl` or `redirectTo` is required */
  redirectTo?: string;
  redirectTarget?: "_blank" | "_self";
};

export interface TableCellActionDataIn extends TableCellAction {
  label?: string; // i18n key
  labelRaw?: string; // key without i18n
  disabled?: (row: unknown) => boolean;
  hidden?: () => boolean;
}

export interface TableCellActionDataOut {
  action: TableCellAction;
  itemId: number | string;
}

export interface TableCellActionData<T> {
  action: TableCellAction;
  item: T;
}
